import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import RequestCardSkeletonMobileList from "./RequestCardSkeletonMobile";

const HistorySkeletonMobile = () => {
  return (
    <Stack sx={{ px: 1, pb: 8 }}>
      {/* Search/Filter Input Skeleton */}
      <Box sx={{ mb: 2 }}>
        <Skeleton 
          variant="rounded" 
          width="100%" 
          height={38} 
          sx={{ borderRadius: 2 }} 
        />
      </Box>

      {/* Status Filter Skeleton */}
      {/* <Box sx={{ mb: 2, display: "flex", gap: 1 }}>
        <Skeleton 
          variant="rounded" 
          width="48%" 
          height={40} 
          sx={{ borderRadius: 2 }} 
        />
        <Skeleton 
          variant="rounded" 
          width="48%" 
          height={40} 
          sx={{ borderRadius: 2 }} 
        />
      </Box> */}

      {/* Request Card Skeletons */}
      <RequestCardSkeletonMobileList rows={5} isHistory={true} />
    </Stack>
  );
};

export default HistorySkeletonMobile;
